import { uploadImage } from '../../../api/imageApi';
import React from 'react';
import { Modal, Box, Typography, Button, CircularProgress } from '@mui/material';
import ImageUploadPreview from './ImageUploadPreview';

export default function ImageUploadDialog({
  open,
  uploadTarget,
  previewImage,
  uploading,
  setUploading,
  setUploadTarget,
  setSelectedFile,
  setPreviewImage,
  handleImageChange,
  onSave
}) {
  const handleClose = () => {
    setUploadTarget(null);
    setSelectedFile(null);
    setPreviewImage(null);
  };

  const handleSave = async () => {
    if (!uploadTarget || (typeof previewImage !== 'string' && previewImage !== null)) {
      console.warn('🚫 Invalid upload target or preview image.');
      return;
    }

    const isImageRemoved = !previewImage && !!uploadTarget?.image;
    const updatedImage = isImageRemoved
      ? ''
      : typeof previewImage === 'string'
        ? previewImage
        : uploadTarget?.image;

    await onSave(updatedImage);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          minHeight: 300,
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant="h6" mb={2}>Upload Image</Typography>
        <ImageUploadPreview
          key={`${uploadTarget?._id || 'new'}-${previewImage || 'none'}`}
          initialUrls={previewImage ? [previewImage] : []}
          maxFiles={1}
          uploadImageFn={async (file, onProgress) => {
            setUploading(true);
            const url = await uploadImage(file, onProgress, { propertyId: uploadTarget?.propertyId });
            setUploading(false);
            return url;
          }}
          onChange={handleImageChange}
          onFullyUploaded={(url) => {
            setPreviewImage(url);
            setUploading(false);
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
          <Button
            variant="contained"
            disabled={uploading}
            startIcon={uploading ? <CircularProgress size={16} color="inherit" /> : null}
            onClick={handleSave}
          >
            {uploading ? 'Uploading...' : 'Save'}
          </Button>
          <Button onClick={handleClose}>Cancel</Button>
        </Box>
      </Box>
    </Modal>
  );
}